import { CountryCode } from '../index.js';
export const locales = [
    { locale: '45', country: 'Denmark' },
    { locale: '46', country: 'Sweden' },
    { locale: '47', country: 'Norway' },
    { locale: '358', country: 'Finland' },
    { locale: '44', country: 'United Kingdom' },
    { locale: '1', country: 'United States' },
    { locale: '93', country: 'Afghanistan' },
    { locale: '355', country: 'Albania' },
    { locale: '213', country: 'Algeria' },
    { locale: '1-684', country: 'American Samoa' },
    { locale: '376', country: 'Andorra' },
    { locale: '244', country: 'Angola' },
    { locale: '1-264', country: 'Anguilla' },
    { locale: '672', country: 'Antarctica' },
    { locale: '1-268', country: 'Antigua and Barbuda' },
    { locale: '54', country: 'Argentina' },
    { locale: '374', country: 'Armenia' },
    { locale: '297', country: 'Aruba' },
    { locale: '61', country: 'Australia' },
    { locale: '43', country: 'Austria' },
    { locale: '994', country: 'Azerbaijan' },
    { locale: '1-242', country: 'Bahamas' },
    { locale: '973', country: 'Bahrain' },
    { locale: '880', country: 'Bangladesh' },
    { locale: '1-246', country: 'Barbados' },
    { locale: '375', country: 'Belarus' },
    { locale: '32', country: 'Belgium' },
    { locale: '501', country: 'Belize' },
    { locale: '229', country: 'Benin' },
    { locale: '1-441', country: 'Bermuda' },
    { locale: '975', country: 'Bhutan' },
    { locale: '591', country: 'Bolivia' },
    { locale: '387', country: 'Bosnia and Herzegovina' },
    { locale: '267', country: 'Botswana' },
    { locale: '55', country: 'Brazil' },
    { locale: '246', country: 'British Indian Ocean Territory' },
    { locale: '1-284', country: 'British Virgin Islands' },
    { locale: '673', country: 'Brunei' },
    { locale: '359', country: 'Bulgaria' },
    { locale: '226', country: 'Burkina Faso' },
    { locale: '257', country: 'Burundi' },
    { locale: '855', country: 'Cambodia' },
    { locale: '237', country: 'Cameroon' },
    { locale: '1', country: 'Canada' },
    { locale: '238', country: 'Cape Verde' },
    { locale: '1-345', country: 'Cayman Islands' },
    { locale: '236', country: 'Central African Republic' },
    { locale: '235', country: 'Chad' },
    { locale: '56', country: 'Chile' },
    { locale: '86', country: 'China' },
    { locale: '61', country: 'Christmas Island' },
    { locale: '61', country: 'Cocos Islands' },
    { locale: '57', country: 'Colombia' },
    { locale: '269', country: 'Comoros' },
    { locale: '682', country: 'Cook Islands' },
    { locale: '506', country: 'Costa Rica' },
    { locale: '385', country: 'Croatia' },
    { locale: '53', country: 'Cuba' },
    { locale: '599', country: 'Curacao' },
    { locale: '357', country: 'Cyprus' },
    { locale: '420', country: 'Czech Republic' },
    { locale: '243', country: 'Democratic Republic of the Congo' },
    { locale: '253', country: 'Djibouti' },
    { locale: '1-767', country: 'Dominica' },
    { locale: '1-809, 1-829, 1-849', country: 'Dominican Republic' },
    { locale: '670', country: 'East Timor' },
    { locale: '593', country: 'Ecuador' },
    { locale: '20', country: 'Egypt' },
    { locale: '503', country: 'El Salvador' },
    { locale: '240', country: 'Equatorial Guinea' },
    { locale: '291', country: 'Eritrea' },
    { locale: '372', country: 'Estonia' },
    { locale: '251', country: 'Ethiopia' },
    { locale: '500', country: 'Falkland Islands' },
    { locale: '298', country: 'Faroe Islands' },
    { locale: '679', country: 'Fiji' },
    { locale: '33', country: 'France' },
    { locale: '689', country: 'French Polynesia' },
    { locale: '241', country: 'Gabon' },
    { locale: '220', country: 'Gambia' },
    { locale: '995', country: 'Georgia' },
    { locale: '49', country: 'Germany' },
    { locale: '233', country: 'Ghana' },
    { locale: '350', country: 'Gibraltar' },
    { locale: '30', country: 'Greece' },
    { locale: '299', country: 'Greenland' },
    { locale: '1-473', country: 'Grenada' },
    { locale: '1-671', country: 'Guam' },
    { locale: '502', country: 'Guatemala' },
    { locale: '44-1481', country: 'Guernsey' },
    { locale: '224', country: 'Guinea' },
    { locale: '245', country: 'Guinea-Bissau' },
    { locale: '592', country: 'Guyana' },
    { locale: '509', country: 'Haiti' },
    { locale: '504', country: 'Honduras' },
    { locale: '852', country: 'Hong Kong' },
    { locale: '36', country: 'Hungary' },
    { locale: '354', country: 'Iceland' },
    { locale: '91', country: 'India' },
    { locale: '62', country: 'Indonesia' },
    { locale: '98', country: 'Iran' },
    { locale: '964', country: 'Iraq' },
    { locale: '353', country: 'Ireland' },
    { locale: '44-1624', country: 'Isle of Man' },
    { locale: '972', country: 'Israel' },
    { locale: '39', country: 'Italy' },
    { locale: '225', country: 'Ivory Coast' },
    { locale: '1-876', country: 'Jamaica' },
    { locale: '81', country: 'Japan' },
    { locale: '44-1534', country: 'Jersey' },
    { locale: '962', country: 'Jordan' },
    { locale: '7', country: 'Kazakhstan' },
    { locale: '254', country: 'Kenya' },
    { locale: '686', country: 'Kiribati' },
    { locale: '383', country: 'Kosovo' },
    { locale: '965', country: 'Kuwait' },
    { locale: '996', country: 'Kyrgyzstan' },
    { locale: '856', country: 'Laos' },
    { locale: '371', country: 'Latvia' },
    { locale: '961', country: 'Lebanon' },
    { locale: '266', country: 'Lesotho' },
    { locale: '231', country: 'Liberia' },
    { locale: '218', country: 'Libya' },
    { locale: '423', country: 'Liechtenstein' },
    { locale: '370', country: 'Lithuania' },
    { locale: '352', country: 'Luxembourg' },
    { locale: '853', country: 'Macau' },
    { locale: '389', country: 'Macedonia' },
    { locale: '261', country: 'Madagascar' },
    { locale: '265', country: 'Malawi' },
    { locale: '60', country: 'Malaysia' },
    { locale: '960', country: 'Maldives' },
    { locale: '223', country: 'Mali' },
    { locale: '356', country: 'Malta' },
    { locale: '692', country: 'Marshall Islands' },
    { locale: '222', country: 'Mauritania' },
    { locale: '230', country: 'Mauritius' },
    { locale: '262', country: 'Mayotte' },
    { locale: '52', country: 'Mexico' },
    { locale: '691', country: 'Micronesia' },
    { locale: '373', country: 'Moldova' },
    { locale: '377', country: 'Monaco' },
    { locale: '976', country: 'Mongolia' },
    { locale: '382', country: 'Montenegro' },
    { locale: '1-664', country: 'Montserrat' },
    { locale: '212', country: 'Morocco' },
    { locale: '258', country: 'Mozambique' },
    { locale: '95', country: 'Myanmar' },
    { locale: '264', country: 'Namibia' },
    { locale: '674', country: 'Nauru' },
    { locale: '977', country: 'Nepal' },
    { locale: '31', country: 'Netherlands' },
    { locale: '599', country: 'Netherlands Antilles' },
    { locale: '687', country: 'New Caledonia' },
    { locale: '64', country: 'New Zealand' },
    { locale: '505', country: 'Nicaragua' },
    { locale: '227', country: 'Niger' },
    { locale: '234', country: 'Nigeria' },
    { locale: '683', country: 'Niue' },
    { locale: '850', country: 'North Korea' },
    { locale: '1-670', country: 'Northern Mariana Islands' },
    { locale: '968', country: 'Oman' },
    { locale: '92', country: 'Pakistan' },
    { locale: '680', country: 'Palau' },
    { locale: '970', country: 'Palestine' },
    { locale: '507', country: 'Panama' },
    { locale: '675', country: 'Papua New Guinea' },
    { locale: '595', country: 'Paraguay' },
    { locale: '51', country: 'Peru' },
    { locale: '63', country: 'Philippines' },
    { locale: '64', country: 'Pitcairn' },
    { locale: '48', country: 'Poland' },
    { locale: '351', country: 'Portugal' },
    { locale: '1-787, 1-939', country: 'Puerto Rico' },
    { locale: '974', country: 'Qatar' },
    { locale: '242', country: 'Republic of the Congo' },
    { locale: '262', country: 'Reunion' },
    { locale: '40', country: 'Romania' },
    { locale: '7', country: 'Russia' },
    { locale: '250', country: 'Rwanda' },
    { locale: '590', country: 'Saint Barthelemy' },
    { locale: '290', country: 'Saint Helena' },
    { locale: '1-869', country: 'Saint Kitts and Nevis' },
    { locale: '1-758', country: 'Saint Lucia' },
    { locale: '590', country: 'Saint Martin' },
    { locale: '508', country: 'Saint Pierre and Miquelon' },
    { locale: '1-784', country: 'Saint Vincent and the Grenadines' },
    { locale: '685', country: 'Samoa' },
    { locale: '378', country: 'San Marino' },
    { locale: '239', country: 'Sao Tome and Principe' },
    { locale: '966', country: 'Saudi Arabia' },
    { locale: '221', country: 'Senegal' },
    { locale: '381', country: 'Serbia' },
    { locale: '248', country: 'Seychelles' },
    { locale: '232', country: 'Sierra Leone' },
    { locale: '65', country: 'Singapore' },
    { locale: '1-721', country: 'Sint Maarten' },
    { locale: '421', country: 'Slovakia' },
    { locale: '386', country: 'Slovenia' },
    { locale: '677', country: 'Solomon Islands' },
    { locale: '252', country: 'Somalia' },
    { locale: '27', country: 'South Africa' },
    { locale: '82', country: 'South Korea' },
    { locale: '211', country: 'South Sudan' },
    { locale: '34', country: 'Spain' },
    { locale: '94', country: 'Sri Lanka' },
    { locale: '249', country: 'Sudan' },
    { locale: '597', country: 'Suriname' },
    { locale: '47', country: 'Svalbard and Jan Mayen' },
    { locale: '268', country: 'Swaziland' },
    { locale: '41', country: 'Switzerland' },
    { locale: '963', country: 'Syria' },
    { locale: '886', country: 'Taiwan' },
    { locale: '992', country: 'Tajikistan' },
    { locale: '255', country: 'Tanzania' },
    { locale: '66', country: 'Thailand' },
    { locale: '228', country: 'Togo' },
    { locale: '690', country: 'Tokelau' },
    { locale: '676', country: 'Tonga' },
    { locale: '1-868', country: 'Trinidad and Tobago' },
    { locale: '216', country: 'Tunisia' },
    { locale: '90', country: 'Turkey' },
    { locale: '993', country: 'Turkmenistan' },
    { locale: '1-649', country: 'Turks and Caicos Islands' },
    { locale: '688', country: 'Tuvalu' },
    { locale: '1-340', country: 'U.S. Virgin Islands' },
    { locale: '256', country: 'Uganda' },
    { locale: '380', country: 'Ukraine' },
    { locale: '971', country: 'United Arab Emirates' },
    { locale: '598', country: 'Uruguay' },
    { locale: '998', country: 'Uzbekistan' },
    { locale: '678', country: 'Vanuatu' },
    { locale: '379', country: 'Vatican' },
    { locale: '58', country: 'Venezuela' },
    { locale: '84', country: 'Vietnam' },
    { locale: '681', country: 'Wallis and Futuna' },
    { locale: '212', country: 'Western Sahara' },
    { locale: '967', country: 'Yemen' },
    { locale: '260', country: 'Zambia' },
    { locale: '263', country: 'Zimbabwe' },
];
const countryCodeToLocale = {
    [CountryCode.NO]: () => '47',
    [CountryCode.SE]: () => '46',
    [CountryCode.DK]: () => '45',
    [CountryCode.GL]: (number) => {
        if (number && number.length === 8) {
            return '45';
        }
        return '299';
    },
};
export const getLocale = (countryCode, number) => {
    return countryCodeToLocale[countryCode](number);
};
//# sourceMappingURL=index.js.map